import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../auth/AuthProvider';
import { FaEye, FaEyeSlash } from 'react-icons/fa';

const UpdatePassword = () => {
  const [newPassword, setNewPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const { updatePassword } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);

    try {
      const { error: updateError } = await updatePassword(newPassword);

      if (updateError) {
        console.error('Password update error:', updateError);
        throw updateError;
      }

      navigate('/calculations');
    } catch (error) {
      console.error('Error updating password:', error);
      setError('Failed to update password. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  const containerStyle = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-start',
    minHeight: '100vh',
    backgroundColor: '#f8f9fa',
    padding: '20px'
  };

  const boxStyle = {
    backgroundColor: 'white',
    padding: '24px',
    borderRadius: '8px',
    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
    width: '100%',
    maxWidth: '400px',
    margin: '0 auto'
  };

  const logoStyle = {
    height: '60px',
    marginBottom: '16px',
    width: 'auto'
  };

  const inputStyle = {
    width: '100%',
    padding: '8px 10px',
    border: '1px solid #ced4da',
    borderRadius: '6px',
    fontSize: '0.95rem',
    height: '36px',
    transition: 'border-color 0.2s',
    '&:focus': {
      borderColor: '#1e3a8a',
      outline: 'none'
    }
  };

  const buttonStyle = {
    width: '100%',
    padding: '10px',
    backgroundColor: '#1e3a8a',
    color: 'white',
    border: 'none',
    borderRadius: '6px',
    cursor: 'pointer',
    fontSize: '0.95rem',
    marginTop: '24px',
    height: '40px',
    transition: 'background-color 0.2s',
    '&:hover': {
      backgroundColor: '#152b5e'
    }
  };

  const linkStyle = {
    color: '#1e3a8a',
    textDecoration: 'none',
    display: 'block',
    marginTop: '24px',
    textAlign: 'center',
    fontSize: '0.95rem',
    transition: 'color 0.2s',
    '&:hover': {
      color: '#152b5e'
    }
  };

  const errorStyle = {
    color: '#dc3545',
    marginBottom: '16px',
    textAlign: 'center',
    fontSize: '0.9rem',
    padding: '8px',
    backgroundColor: '#f8d7da',
    borderRadius: '4px',
    border: '1px solid #f5c6cb'
  };

  const inputGroupStyle = {
    position: 'relative',
    marginTop: '20px',
    width: '100%'
  };

  const toggleButtonStyle = {
    position: 'absolute',
    right: '10px',
    top: '50%',
    transform: 'translateY(-50%)',
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    color: '#6c757d',
    padding: '5px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '30px',
    height: '30px'
  };

  const titleStyle = {
    margin: '0 0 16px 0',
    color: '#1e3a8a',
    fontSize: '1.5rem',
    fontWeight: '600'
  };

  return (
    <div style={containerStyle}>
      <div style={boxStyle}>
        <div style={{ textAlign: 'center' }}>
          <img 
            src="/logo.png" 
            alt="Pre Go Prep" 
            style={logoStyle}
          />
          <h2 style={titleStyle}>Update Password</h2>
        </div>

        {error && <div style={errorStyle}>{error}</div>}


        <form onSubmit={handleSubmit}>
          <div style={inputGroupStyle}>
            <input
              type={showPassword ? "text" : "password"}
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              placeholder="Enter new password"
              style={inputStyle}
              required
                disabled={isLoading}
            />
            <button
              type="button"
              onClick={() => setShowPassword(!showPassword)}
              style={toggleButtonStyle}
              aria-label={showPassword ? "Hide password" : "Show password"}
                disabled={isLoading}
            >
              {showPassword ? <FaEyeSlash /> : <FaEye />}
            </button>
          </div>

            <button type="submit" style={buttonStyle} disabled={isLoading}>
            Update Password
          </button>
        </form>

        <Link to="/login" style={linkStyle}>
          Back to Login
        </Link>
      </div>
    </div>
  );
};

export default UpdatePassword;